import Product from "../../../../../../@types/Product";


const LsvKit: Product[] = [
    {
        id: 1,
        name: 'LSV Kit',
        sku: '03-228',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/lsv-kit/lsv-kit.png`,
        price: 485.00,
        retailPrice: 0.00,
    },
    {
        id: 2,
        name: 'No LSV Kit',
        sku: 'None',
        img: `${process.env.PUBLIC_URL}/display-order/no-option.png`,
        price: 0.00,
        retailPrice: 0.00,
    }
];

const LsvKitPreassembled: Product[] = [
    {
        id: 1,
        name: 'LSV Kit',
        sku: '03-228',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/lsv-kit/lsv-kit.png`,
        price: 635.00,
        retailPrice: 0.00,
        
    },
    {
        id: 2,
        name: 'No LSV Kit',
        sku: 'None',
        img: `${process.env.PUBLIC_URL}/display-order/no-option.png`,
        price: 0.00,
        retailPrice: 0.00,
    }
]

export { LsvKitPreassembled, LsvKit };